import { useEffect, useState } from 'react';

interface ShareDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
}

const channels = [
  { key: 'weibo', label: '微博', icon: 'ri-weibo-line' },
  { key: 'wechat', label: '微信', icon: 'ri-wechat-line' },
  { key: 'qq', label: 'QQ', icon: 'ri-qq-line' },
  { key: 'link', label: '复制链接', icon: 'ri-link' },
];

export default function ShareDialog({ open, onClose, title }: ShareDialogProps) {
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!open) setMessage('');
  }, [open]);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (open) document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  const handleShare = async (key: string, label: string) => {
    const url = window.location.href;
    if (key === 'link') {
      try {
        await navigator.clipboard.writeText(url);
        setMessage('链接已复制到剪贴板');
      } catch {
        setMessage('复制失败，请手动复制地址栏链接');
      }
      return;
    }
    setMessage(`演示功能：已生成「${title}」的${label}分享内容`);
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/45" onClick={onClose}></div>
      <div className="relative w-full max-w-md rounded-lg bg-background-50 p-6 animate-fade-up">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h2 className="text-lg font-bold font-heading text-foreground-950">分享这条资讯</h2>
            <p className="mt-1 text-sm text-foreground-500 line-clamp-1">{title}</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="w-8 h-8 rounded-md flex items-center justify-center text-foreground-500 hover:bg-background-100 transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>

        <div className="mt-6 grid grid-cols-4 gap-3">
          {channels.map((c) => (
            <button
              key={c.key}
              type="button"
              onClick={() => handleShare(c.key, c.label)}
              className="flex flex-col items-center gap-2 py-3 rounded-md hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span className="w-11 h-11 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center">
                <i className={`${c.icon} text-xl`}></i>
              </span>
              <span className="text-xs text-foreground-700 whitespace-nowrap">{c.label}</span>
            </button>
          ))}
        </div>

        {message && (
          <p className="mt-5 rounded-md bg-accent-100 px-3 py-2.5 text-sm text-accent-800 animate-fade-in">{message}</p>
        )}

        <p className="mt-4 text-xs text-foreground-400">
          注：分享为前端演示功能，不会真实发布到第三方平台。
        </p>
      </div>
    </div>
  );
}